import {INIT_CHAT_ROOM} from "@constants/action-type/chat-room-action-type";
import {deepClone} from "@utils/func";
import Base64 from "@utils/base64-utils"

export default {
    namespaced: true,
    state: {
        socket: null,
        msgList: [],
        currentUser: {},
        groups: []
    },
    mutations: {
        initChatRoom(state, {socket}) {
            state.socket = socket;
        },
        // 接收到聊天响应处理
        chatResp(state, payload) {
            payload.data.avatar = unescape(payload.data.avatar)
            state.msgList.push(payload.data)
        },
        // 有人加入群聊处理
        onAddGroup(state, {nick}) {
            // eslint-disable-next-line no-debugger
            state.msgList.push({
                isSystemMsg: true,
                msg: nick + '加入了群聊'
            })
        },
        onAddSystemMsg(state, payload) {
            state.msgList.push({
                // 自定义的msgType
                isSystemMsg: true,
                msg: payload.msg
            });
        },
        // 当前在线用户
        setCurrentUser(state, payload) {
            state.currentUser = payload.data;
            state.groups = payload.groups.map(item => {
                return {
                    ...item,
                    avatar: item.avatar ? Base64.decode(item.avatar) : ""
                }
            });
        },
        // 处理历史消息
        setHistoryMsg(state, {groupMsgList}) {
            const msgList = deepClone(state.msgList, []);
            if (groupMsgList) {
                groupMsgList.forEach(item => {
                    item.avatar = unescape(item.avatar);
                    msgList.push(item);
                });
            }
            state.msgList = msgList;
        }
    },
    actions: {
        [INIT_CHAT_ROOM]({commit, rootState}, {courseId}) {
            //todo 放到数据字典里维护
            const username = rootState.login.userInfo.loginName ? rootState.login.userInfo.loginName : rootState.login.userInfo.mobile;
            const nickName = rootState.login.userInfo.nickname;

            let avatar = rootState.login.userInfo.avatarUrl
            if (avatar) {
                // eslint-disable-next-line no-unused-vars
                avatar = Base64.encode(rootState.login.userInfo.avatarUrl);
            } else {
                avatar = ""
            }
            // const avatar = escape(Base64._utf8_encode(rootState.login.userInfo.avatarUrl));
            // 加载这个的时候一定时已经登录过的
            const socket = new WebSocket(`wss:course.myhope365.com/websocketChat?username=${username}&password=mengbole&courseId=${courseId}&nickName=${nickName}&avatar=${avatar}`);
            let liveStateIntervalId = null;
            // 如果连接成功后，加载历史记录
            socket.onopen = () => {
                let msgHistoryCmd = JSON.stringify({
                    cmd: 19, type: 1, groupId: courseId, userId: username
                });
                socket.send(msgHistoryCmd);
                liveStateIntervalId = setInterval(() => {
                    // 获取直播状态
                    let heartbeatCmd = "{\"cmd\":13,\"hbbyte\":\"-127\"}";
                    socket.send(heartbeatCmd);
                }, 5000);

            };
            socket.onerror = (e) => {
                console.log("异常:" + e);
                commit('onAddSystemMsg', {msg: "异常:" + e})
            };
            socket.onclose = () => {
                // 关闭时候的操作
                // 1. 清除当前登录用户
                // 2. 清除用户分组成员
                commit("setCurrentUser", {groups: []});
                // 3. 关闭连接的字
                commit('onAddSystemMsg', {msg: "关闭连接..."});
                console.log("===================关闭连接===================");
                // 4.清除定时器
                clearInterval(liveStateIntervalId);
            };

            // 监听消息变化
            socket.onmessage = (e) => {
                let data = e.data;
                let dataObj = eval("(" + data + ")");//转换为json对象
                //接收到聊天响应处理;
                if (dataObj.command === 11) {
                    commit("chatResp", dataObj);
                } else if (dataObj.command === 18) {
                    //获取用户信息响应处理;=// 获取当前在线用户 ，其中group是当前在线用户
                    let groups = [];
                    for (let group of dataObj.data.groups) {
                        if (group.group_id == courseId) {
                            groups = group.users;
                        }
                    }
                    commit('setCurrentUser', {...dataObj, groups});
                } else if (10000 === dataObj.code && dataObj.command === 12) {
                    //聊天发送状态
                    console.log("=============发送成功=============");
                    console.log(dataObj);
                    console.log("=============发送成功=============");
                } else if (dataObj.command === 9) {
                    //加入群组的消息通知处理;
                    // 如果时当前直播间的群聊信息，则进行处理
                    if (String.valueOf(courseId) === String.valueOf(dataObj.data.group)) {
                        // 1. 向数组中插入一个数据， 通知某某某加入了直播间
                        // 如果这个分组等于当前的id发送
                        if (dataObj.data.group == courseId) {
                            commit('onAddGroup', dataObj.data.user);
                        }
                        // 2. 重新获取当前直播间人数
                        socket.send(JSON.stringify({cmd: 17, type: 0, userid: username}));//获取在线用户列表;
                    }
                } else if (dataObj.command === 10) {
                    //退出群组的消息通知处理;
                    // 1. 向数组中插入一个数据， 通知某某某退出了直播间
                    if (dataObj.data.group == courseId) {
                        // commit('onAddSystemMsg', {msg: dataObj.data.user.nick + "退出了聊天室"})
                    }
                    // 2. 重新获取当前直播间人数,获取在线用户列表;
                    socket.send(JSON.stringify({cmd: 17, type: 0, userid: username}));
                } else if (dataObj.command === 20 && dataObj.code === 10015) {
                    //获取消息失败，未开启持久化处理 聊天室
                    console.warn("获取消息失败，未开启持久化处理 聊天室...");
                } else if (dataObj.command === 20 && dataObj.code === 10016) {
                    // 处理离线消息; todo 暂不处理离线消息
                    // 处理消息内容;
                } else if (dataObj.command === 20 && dataObj.code === 10018) {
                    //处理历史消息;
                    let msgObj = dataObj.data;
                    if (msgObj) {
                        // 处理历史消息
                        commit('setHistoryMsg', {groupMsgList: msgObj.groups[courseId]});
                        // 这里不涉及 好友消息，只涉及分组消息，故不对好友消息进行处理
                        // let friends = msgObj.friends;
                    } else {
                        //没有历史消息;
                        console.log("没有历史消息");
                    }
                } else if (dataObj.command === 6) {
                    //登陆命令返回状态处理
                    if (10007 === dataObj.code) {//登陆成功;
                        commit('onAddSystemMsg', {msg: "连接成功"});
                        //获取登录用户信息;
                        socket.send(JSON.stringify({cmd: 17, type: 0, userid: username}));
                        //获取用户离线消息(好友+群组);
                        socket.send(JSON.stringify({cmd: 19, type: 0, userId: username}));
                    } else if (10008 === dataObj.code) {//登录失败;
                        commit('onAddSystemMsg', {msg: "登录失败"})
                    }
                } else if (dataObj.command === 13) {
                    // 心跳检测，不通知
                } else {
                    // 其他消息类型
                    commit('onAddSystemMsg', {msg: data})
                }
            };
            commit("initChatRoom", {socket});
        },

    }
}
